'use client'

import { FC } from 'react'
import { useTranslations } from 'next-intl'
import Title from '@/app/components/common/Title'
import { BlogPost } from '@/app/types/blog'
import BlogCard from './BlogCard'
import '@/app/styles/components/RelatedArticles.css'

interface Props {
	posts: BlogPost[]
	lang: string
}

const RelatedArticles: FC<Props> = ({ posts, lang }) => {
	const t = useTranslations('Blog')

	if (!posts || posts.length === 0) return null

	return (
		<div className="related-articles">
			<Title level={2} bold color="text-950" className="related-articles__title" testId="related-articles-title">
				{t('relatedArticles')}
			</Title>
			<div className="related-articles__grid">
				{posts.map((post) => (
					<BlogCard key={post._id} post={post} lang={lang} />
				))}
			</div>
		</div>
	)
}

export default RelatedArticles
